import { render, staticRenderFns } from "./OrdersFBMEditingPageAdmin.vue?vue&type=template&id=550629ab&scoped=true"
import script from "./OrdersFBMEditingPageAdmin.vue?vue&type=script&lang=js"
export * from "./OrdersFBMEditingPageAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550629ab",
  null
  
)

export default component.exports